// Used in singular-assignment.component.html, view-assignment.component.html, activity-preview-dialog.component.html, and composite-assignment-submit.component.html

// Angular
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

// Services/Types/Helpers
import { AssignmentHelper } from "#helpers/assignment.helper";
import { Asset, ExtLink } from "@carnegie-learning/cure-types";
import {
    PPAssignment as Assignment,
    CompositeTaskAssignment,
} from "cli-types";

@Component({
    selector: "math-ext-link-activity",
    templateUrl: "./math-ext-link-activity.component.html",
    styleUrls: ["./math-ext-link-activity.component.scss"],
    standalone: false
})
export class MathExtLinkActivityComponent implements OnInit {
    isDownloaded = false;
    fileFormat: string;
    @Input() asset: ExtLink;
    @Input() assignment: Assignment | CompositeTaskAssignment | undefined;
    @Output() submitEvent = new EventEmitter<
        CompositeTaskAssignment | Assignment
    >();

    constructor(private assignmentHelper: AssignmentHelper) {}

    ngOnInit(): void {
        if (!this.asset) {
            this.asset = <ExtLink>this.assignment?.asset;
        }
        this.isDownloaded = this.assignment?.completedAt != null;
        this.fileFormat = this.getFileFormat(<ExtLink>this.asset);
    }

    launchLink(asset: Asset | undefined) {
        window.open((<ExtLink>asset).launchLink);
        this.isDownloaded = true;
    }

    getFileFormat(asset: ExtLink): string {
        return this.assignmentHelper.getFileType(asset);
    }

    markAsSubmitted() {
        this.submitEvent.emit(this.assignment);
    }
}
